import * as Yup from 'yup';

import { nameValidationSchema } from '../validations';

export const accommodationValidationSchema = Yup.object().shape({
    name: nameValidationSchema
});
